import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { faPencilAlt as falPencil } from "@fortawesome/pro-light-svg-icons";
import { faSave as falSave } from "@fortawesome/free-solid-svg-icons";
import { faSave as fasSave } from "@fortawesome/pro-solid-svg-icons";
import {
  VAIconRegistryService,
  edit,
  exclamationTriangle,
} from "@va/core-library/icons";
@Component({
  selector: "app-edit-name-input",
  templateUrl: "./edit-name-input.component.html",
  styleUrls: ["./edit-name-input.component.scss"],
})
export class EditNameInputComponent implements OnInit {
  @Input() chartName: string;
  @Input() isEditable: boolean;
  nameError = "";
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Output() saveAsCustom: EventEmitter<any> = new EventEmitter();

  inEditMode: boolean;
  fasSave = fasSave;
  falSave = falSave;
  falPencil = falPencil;
  @ViewChild("chartRename") reNameField: ElementRef;

  constructor(private iconRegistryService: VAIconRegistryService) {
    this.iconRegistryService.registerIcons([exclamationTriangle, edit]);
  }

  ngOnInit() {
    this.inEditMode = false;
  }

  setEditMode = () => {
    if (this.isEditable) {
      this.inEditMode = true;
      setTimeout(() => {
        this.reNameField.nativeElement.focus();
      }, 100);
    }
  };

  //checks validation of input.
  // called when focus is removed from watchlist rename text box
  onNameChange() {
    if (this.chartName === "") {
      this.nameError = "Chart Name cannot be blank.";
    } else {
      this.nameError = "";
    }
  }

  toggleEditMode = () => {
    this.inEditMode = !this.inEditMode;
    if (this.inEditMode) {
      setTimeout(() => {
        this.reNameField.nativeElement.focus();
      }, 100);
    }

    if (!this.inEditMode) {
      if (this.chartName !== "") {
        if (!this.isEditable) {
          this.saveAsCustom.emit(this.chartName);
        } else {
          this.onChange.emit(this.chartName);
        }
      } else {
        this.inEditMode = !this.inEditMode;
      }
    }
  };
}
